// the values of these also correspond to the values when 
// setting the 'mode' property of the TransformControls in three.js
export enum TransformControlType {
  Translation = 'translate',
  Rotation = 'rotate',
  SnapToVolume = 'snap-to-volume'
}
